module.exports = __webpack_public_path__ + "static/media/cap2-01-desk.7ee2ee33.png";